<script lang="ts">
	import GlobalMedia from '../media/GlobalMedia.svelte';

	export let value: string;
	export let type: 'normal' | 'small' = 'normal';
	let ref: HTMLSelectElement;
</script>

<div class="dropdown {type}">
	<select id="select" bind:value bind:this={ref} on:input>
		<slot />
	</select>
	<div class="icon">
		<GlobalMedia key="icon-caret-down" />
	</div>
</div>

<style lang="scss">
	$iconWidth: 0.75rem;
	$iconWidthSmall: 0.6rem;
	.dropdown {
		width: 100%;
		height: v(input__height);
		border: none;
		background-color: color(white);
		border-radius: v(input__border-radius);
		overflow: hidden;
		// display: grid;
		// grid-template-columns: auto 1.75rem;
		// gap: v(content-gap-sm);
		position: relative;

		select {
			width: 100%;
			height: 100%;
			border: none;
			background: none;
			appearance: none;
			text-indent: 0;
			-webkit-appearance: none;

			padding-inline-start: v(content-padding-sm);
		}

		&.normal select {
			@include font(text);
			padding-top: 9px;
			padding-bottom: 9px;
			padding-inline-end: calc(2 * v(content-padding-sm) + $iconWidth);
		}

		&.small select {
			@include font(text-sm);
			padding-top: 8px;
			padding-bottom: 5px;
			padding-inline-end: calc(2 * v(content-padding-sm) + $iconWidthSmall);
			background: color(grey_02);
		}

		.icon {
			pointer-events: none;
			position: absolute;
			inset-inline-end: v(content-padding-sm);
			top: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			width: $iconWidth;
			height: 100%;

			:global(svg) {
				width: 100%;
				height: 100%;

				:global(path) {
					fill: color(black);
				}
			}
		}

		&.small .icon {
			width: $iconWidthSmall;
		}
	}
</style>
